import React, { useState } from 'react'
import { Row, Col } from '@themesberg/react-bootstrap'

const LogoUpload = ({ setFieldValue, values, createTenantData }) => {
  const [selectedImage, setSelectedImage] = useState(null)
  const [imgError, setImgError] = useState(false)
  const onFileChange = (file) => {
    setImgError(false)
    setSelectedImage(file)
    setFieldValue('logo', file)
  }

  return (
    <Row>
      <Col xs>
        <div className='d-grid'>
          <input
            name='logo'
            className='mb-2'
            type='file'
            onChange={(event) => {
              onFileChange(event.target.files[0])
            }}
          />

          {imgError && (
            <span className='text-danger'>
              File Size Should Be Less Than 1 MB
            </span>
          )}

          {selectedImage
            ? (
              <img
                alt='not found'
                style={{ maxWidth: '300px', maxHeight: '300px' }}
                src={URL.createObjectURL(selectedImage)}
              />
              )
            : (
                createTenantData.logo && (
                  <img alt='not found' style={{ maxWidth: '300px', maxHeight: '300px' }} src={createTenantData.logo} />
                )
              )}
        </div>
      </Col>
    </Row>
  )
}

export default LogoUpload
